// src/components/utils/dateHelpers.js:

export const formattedOpenDate = (date) => {
  let opendate = new Date(date);

  if (isNaN(opendate.getDate())) {
    const [month, year] = date.split(" ");
    if (month && year) {
      opendate = new Date(`${month} 1, ${year}`);
    } else {
      console.error("Invalid date format for openDate:", date);
      return "Invalid Date";
    }
  }

  const formattedDate = opendate.toLocaleDateString("en-US", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
    timeZone: "America/Los_Angeles",
  });

  const formattedTime = "9:00 am";

  return `${formattedDate} at ${formattedTime}`;
};

export const formatDateToLocalAmericaPacific = (date) => {
  return new Date(date).toLocaleString("en-US", {
    timeZone: "America/Los_Angeles",
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

export const calculateScholarshipYear = () => {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: "America/Los_Angeles",
    year: "numeric",
    month: "numeric",
  }).formatToParts(new Date());

  const year = Number(parts.find((p) => p.type === "year")?.value);
  const month = Number(parts.find((p) => p.type === "month")?.value);
  return month >= 9 ? year + 1 : year;
};

/**
 * Calculates the tax year based on the given scholarship year.
 * @param {number} scholarshipYear - The year of the scholarship.
 * @returns {number} The corresponding tax year.
 */
export const calculateTaxYear = (scholarshipYear) => {
  // console.log("scholarshipYear:", scholarshipYear);
  if (!scholarshipYear) {
    throw new Error("Invalid scholarship year provided.");
  }
  return scholarshipYear - 1;
};

export const formattedDeadlineDate = (dateInput) => {
  if (!dateInput) return "";

  const d = new Date(dateInput);
  if (Number.isNaN(d.getTime())) return "";

  return d.toLocaleString(undefined, {
    weekday: "long", // 👈 adds Thursday
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
};
